<template>
  <section id="relic-detail-base">
    <edit-header-vue
      title="基本信息"
      v-model="visibleEdit"
      @onActionClick="handleActionClick"
      @onSaveClick="handleSaveBasicRelic"
      @onCancelClick="handleCancelBasicRelic"
    />

    <div class="base-content">
      <relic-detail-base-upload-vue
        @onLocalUpdateCover="handleLocalUpdateCover"
        @onUpdateFromPhotoAlbum="handleUpdateFromPhotoAlbum"
      />

      <section class="base-content__inputs">
        <edit-input-vue
          v-model="modelValue[baseOption.value]"
          v-for="(baseOption, index) in baseOptions"
          :key="index"
          :edit="visibleEdit"
          :label="baseOption.label"
          :options="baseOption.options || {}"
          :placeholder="baseOption.placeholder || ''"
        >
        </edit-input-vue>
        <edit-input-vue
          label="建筑坐标"
          placeholder="坐标填写格式为：经度，纬度"
          v-model="coordinate"
          :edit="false"
        >
          <!-- 建筑坐标时 后置插槽 -->
          <template v-slot:append>
            <el-button
              type="text"
              class="base-content__mapicon"
              icon=" iconfont icon-dingwei"
              @click="handleMapIconClick"
            ></el-button>
          </template>
        </edit-input-vue>
        <edit-input-vue
          label="建筑地址"
          v-model="modelValue.relicAddress"
          :options="{ type: 'textarea' }"
          :edit="visibleEdit"
        />
        <edit-input-vue label="更新时间" :value="updateTime" />
      </section>
    </div>
    <!-- <edit-input-vue
      v-model="modelValue[baseOption.value]"
      v-for="(baseOption, index) in baseOptionsII"
      :key="index"
      :edit="visibleEdit"
      :label="baseOption.label"
      :options="baseOption.options || {}"
      :placeholder="baseOption.placeholder || ''"
    >
    </edit-input-vue> -->
    <div
      class="relic-base__intro"
      v-for="(baseOption, index) in baseOptionsII"
      :key="index"
    >
      <div class="font-labelheavy edit-input__label">
        {{ baseOption.label }}
      </div>
      <el-input
        :readonly="!visibleEdit"
        :autosize="true"
        v-model="modelValue[baseOption.value]"
        class="relic-intro__name"
        :type="baseOption.type || 'textarea'"
        :class="{ readonly: !visibleEdit }"
      ></el-input>
    </div>
    <div class="relic-base__intro">
      <div class="font-labelheavy edit-input__label">点云模型</div>
      <el-input
        v-show="!modelValue.pointCloudUrl || visibleEdit"
        :readonly="!visibleEdit"
        :autosize="true"
        v-model="modelValue.pointCloudUrl"
        class="relic-intro__name"
        placeholder="请输入点云模型链接"
        type="text"
        :class="{ readonly: !visibleEdit }"
      ></el-input>
      <a
        v-show="modelValue.pointCloudUrl && !visibleEdit"
        :href="modelValue.pointCloudUrl"
        target="_blank"
        ><el-button>前往</el-button></a
      >
    </div>
    <div class="relic-base__intro">
      <div class="font-labelheavy edit-input__label">实景模型</div>
      <el-input
        v-show="!modelValue.realSceneryModel || visibleEdit"
        :readonly="!visibleEdit"
        :autosize="true"
        v-model="modelValue.realSceneryModel"
        class="relic-intro__name"
        placeholder="请输入实景模型链接"
        type="text"
        :class="{ readonly: !visibleEdit }"
      ></el-input>
      <a
        :href="modelValue.realSceneryModel"
        target="_blank"
        v-show="modelValue.realSceneryModel && !visibleEdit"
      >
        <el-button>前往</el-button>
      </a>
    </div>
    <div class="relic-base__intro">
      <div class="font-labelheavy edit-input__label">建筑简介</div>
      <el-input
        :readonly="!visibleEdit"
        :autosize="true"
        v-model="modelValue.relicIntroduction"
        class="relic-intro__name"
        placeholder="请输入建筑简介"
        type="textarea"
        :class="{ readonly: !visibleEdit }"
      ></el-input>
    </div>
    <el-button
      style="width:auto;padding:5px;margin-top:20px"
      class="save-flex-btn"
      v-show="visibleEdit"
      @click="handleSaveAllUp"
      >保存基本信息</el-button
    >
    <!-- 地图弹窗 -->
    <relic-detail-base-map-vue
      v-model="visibleMap"
      :coordinate="coordinate"
      @onConfirmClick="handleMaplnglatGet"
    />
  </section>
</template>

<script>
import editInputVue from '../layout/edit-input.vue';
import editHeaderVue from '../layout/edit-header.vue';
import relicDetailBaseMapVue from './relic-detail-base-map.vue';
import relicDetailBaseUploadVue from './relic-detail-base-upload.vue';
import { updateRelicBasicDetail } from '../../api/index';
import { wgs84togcj02 } from '../../config/transformCoodornate';
import { SELECT_AREA, SELECT_LEVEL, SELECT_TYPE } from '../../config/constant';
import { modelMixin } from '../../assets/js/mixins/model';
import { mapActions } from 'vuex';

function transformCoordinatexy(coordinate) {
  return coordinate?.x ? `${coordinate.x},${coordinate.y}` : '';
}

export default {
  name: 'RelicDetailBase',
  computed: {
    pid() {
      let pid = this.realSceneryModel.split('=')[1];
      return pid;
    },
    updateTime: {
      get() {
        return this.formatDateTime(this.modelValue.updateTime);
      }
    },
    coordinate: {
      get() {
        return transformCoordinatexy(this.modelValue.coordinate);
      },
      set(value) {
        const [x, y] = value.split(',');
        this.modelValue.coordinate = { x, y };
      }
    }
  },
  mixins: [modelMixin],
  components: {
    editHeaderVue,
    editInputVue,
    relicDetailBaseMapVue,
    relicDetailBaseUploadVue
  },
  data() {
    return {
      gaodeCoordinate: 'gaodeCoordinate',
      pointCloudUrl: 'pointCloudUrl',
      relicIntroduction: 'relicIntroduction',
      realSceneryModel: 'realSceneryModel',
      baseOptions: [
        {
          label: '建筑年代',
          value: 'relicAge'
        },
        {
          label: '建筑类别',
          value: 'relicTypeEnum',
          options: {
            type: 'select',
            list: SELECT_TYPE
          }
        },
        {
          label: '保护级别',
          value: 'protectionLevelEnum',
          options: {
            type: 'select',
            list: SELECT_LEVEL
          }
        },
        {
          label: '所在区域',
          value: 'relicDistrictEnum',
          options: {
            type: 'select',
            list: SELECT_AREA
          }
        }
      ], // 基础信息中需要编辑更改的内容
      baseOptionsII: [
        {
          label: '建筑风格',
          value: 'architecturalStyle'
        },
        {
          label: '环境氛围',
          value: 'atmosphere'
        },
        {
          label: '建筑开间数',
          value: 'bayWidth'
        },
        {
          label: '建筑环境',
          value: 'buildingEnvironment'
        },
        {
          label: '建筑评级',
          value: 'buildingRating'
        },
        {
          label: '建筑层数',
          type: 'number',
          value: 'buildingStoreys'
        },
        {
          label: '类别',
          value: 'buildingType'
        },
        {
          label: '建筑面积',
          value: 'constructionArea'
        },
        {
          label: '损坏原因',
          value: 'damageCause'
        },
        {
          label: '特色工艺',
          value: 'featuredCrafts'
        },
        {
          label: '历史环境',
          value: 'historicalEnvironment'
        },
        {
          label: '历史功能',
          value: 'historyFunction'
        },
        {
          label: '占地面积',
          value: 'landArea'
        },
        {
          label: '名称沿革',
          value: 'nameEvolution'
        },
        {
          label: '历史原貌',
          value: 'originalAppearanceOfHistory'
        },
        {
          label: '所有权',
          value: 'ownership'
        },
        // {
        //   label: '校对状态',
        //   value: 'proofreadingStatus'
        // },
        {
          label: '建议保护',
          value: 'recommendedProtection'
        },
        {
          label: '屋顶形式',
          value: 'roofForm'
        },
        {
          label: '评分',
          value: 'score',
          type: 'number'
        },
        {
          label: '特定类型',
          value: 'specificType'
        },
        {
          label: '现状描述',
          value: 'statusQuoDescription'
        },
        {
          label: '现状功能',
          value: 'statusQuoFunction'
        },
        {
          label: '结构类型',
          value: 'structureType'
        },
        {
          label: '隶属',
          value: 'subjection'
        },
        {
          label: '使用单位',
          value: 'userUnit'
        },
        {
          label: '价值判断',
          value: 'valueJudgement'
        }
      ],
      visibleEdit: false, // 控制是否显示编辑状态
      visibleMap: false // 控制是否显示地图弹窗
    };
  },

  methods: {
    handleSaveAllUp() {
      this.visibleEdit = false;
      this.handleSaveBasicRelic();
    },

    /**
     * * 编辑按钮点击回调
     */
    handleActionClick() {
      this.$parent.headerEditFlag = !this.$parent.headerEditFlag;
    },

    /**
     * 更新基本信息
     */
    async handleSaveBasicRelic() {
      console.log(this.modelValue);
      let coordinateX = '';
      let coordinateY = '';
      if (this.modelValue.coordinate) {
        coordinateX = this.modelValue.coordinate.x;
        coordinateY = this.modelValue.coordinate.y;
      }
      const params = Object.assign({}, this.modelValue, {
        coordinateX,
        coordinateY
      });
      await updateRelicBasicDetail(params);
      await this.initBaseInfo();
    },

    async initBaseInfo() {
      await this.getBaseRelicInfo(this.modelValue.relicAutoIncrementId);
      this.$parent.headerEditFlag = false;
      this.$prompt('修改成功');
    },

    /**
     * 监听取消回调
     */
    async handleCancelBasicRelic() {
      this.initBaseInfo();
    },
    /**
     * * 地图弹窗icon点击回调
     */
    handleMapIconClick() {
      this.visibleMap = true;
    },

    /**
     * * 获取选择经纬度回调
     */
    handleMaplnglatGet(lnglat, gaodeCoordinate) {
      this.coordinate = lnglat;
      this.modelValue.gaodeCoordinate = gaodeCoordinate;
    },
    /**
     * 监听更新图片回调
     */
    async handleLocalUpdateCover() {
      this.initBaseInfo();
    },
    /**
     * 监听从图库更新毁掉
     */
    async handleUpdateFromPhotoAlbum() {
      this.initBaseInfo();
    },
    ...mapActions('relic', ['getBaseRelicInfo'])
  }
};
</script>

<style lang="scss">
#relic-detail-base {
  .base {
    &-content {
      display: flex;
      margin-top: 10px;
      align-items: flex-end;
      &__inputs {
        margin-left: 140px;
      }
      &__mapicon {
        position: absolute;
        text-decoration: none;
        top: 50%;
        right: 0;
        transform: translateY(-58%);
        .iconfont {
          font-size: 30px;
        }
      }
    }
  }
  .save-flex-btn {
    position: fixed;
    top: 50%;
    right: 10px;
  }
  .edit-input {
    position: relative;
  }
  .relic-base__intro {
    margin-top: 10px;
  }
  .relic-intro__name {
    width: 845px;
    .el-textarea {
      &__inner {
        padding: 0 3px;
        height: 28px;
        font-size: 13px;
        line-height: 28px;
        letter-spacing: 2px;
        resize: none;
        border-radius: unset;
        border: 0;
        box-shadow: inset 0px 0px 3px 0px rgba(2, 125, 180, 0.7);
      }
      &__suffix {
        &-inner {
          display: flex;
          align-items: center;
          height: 100%;
        }
      }
    }
    &.readonly {
      .el-textarea__inner {
        font-size: 14px;
        color: #003333;
        box-shadow: none;
      }
    }
    &.readonly {
      .el-input__inner {
        font-size: 14px;
        color: #003333;
        box-shadow: none;
      }
    }
    .el-input__inner {
      padding: 0 3px;
      height: 30px;
      font-size: 13px;
      line-height: 30px;
      color: #000;
      border: 0;
      border-radius: unset;
      box-shadow: inset 0px 0px 3px 0px rgba(2, 125, 180, 0.7);
    }
    .edit-input__label {
      font-size: 14px;
      color: #003333;
      box-shadow: none;
    }
    // .el-textarea__inner {
    //   padding: 0 3px;
    //   height: 30px;
    //   font-size: 13px;
    //   line-height: 30px;
    //   color: #000;
    //   border: 0;
    //   border-radius: unset;
    //   box-shadow: inset 0px 0px 3px 0px rgba(2, 125, 180, 0.7);
    // }
  }
}
</style>
